import { UserManager } from 'oidc-client'

const OidcSettings = {
  authority: `${process.env.REACT_APP_TSC_OIDC_AUTHORITY}/oidc/2`,
  client_id: process.env.REACT_APP_TSC_OIDC_CLIENTID,
  redirect_uri: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_OIDC_REDIRECT_URL_DEVELOPMENT : process.env.REACT_APP_OIDC_REDIRECT_URL,
  response_type: 'id_token token',
  scope: 'openid profile params',
  post_logout_redirect_uri: process.env.REACT_APP_TSC_OIDC_AUTHORITY,
  automaticSilentRenew: true,
  silent_redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URL,
  extraQueryParams: {
    audiences: 'https://my.amnpassport.com/'
  }
}

export const userManager = new UserManager(OidcSettings)
